<div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
    <table class="table">
        <thead>
            <th>Router Name</th>
            <th>Router Type</th>
            <th>Channel</th>
            <th>Master</th>
            <th class="text-right" [hidden]="eventFinished">Actions</th>
        </thead>
        <tbody>
            <tr *ngFor="let router of event.routers">
                <td>{{router.name}}</td>
                <td>{{router.routerType.name}}</td>
                <td>{{router.channel}}</td>
                <td>{{router.master}}</td>
                <td class="text-right" [hidden]="eventFinished">
                    <button type="button" class="btn btn-sm btn-primary"
                        (click)="unassociateRouterFromEventClick(router)">Remove</button>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="card" *ngIf="freeRealRouterAmount > 0">
        <div class="card-body" style="padding-bottom: 0px;">
            <div class="form-row align-items-center" [hidden]="eventFinished">
                <div class="col">
                    <app-select label="Router Name" [options]=availableRouterOptions [(model)]="routerId"
                        (modelChange)="onRouterSelectChange()"></app-select>
                </div>
                <div class="col">
                    <app-form-group-input label="Channel" [disabled]="true" [(model)]="selectedRouter.channel">
                    </app-form-group-input>
                </div>
                <div class="col">
                    <app-form-group-input label="Master" [disabled]="true" [(model)]="selectedRouter.master">
                    </app-form-group-input>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-sm btn-default"
                        (click)="associateRouterToEventClick()">Add</button>
                </div>
            </div>
        </div>
    </div>
</div>